import type { InstrumentDisplayDataResponse } from '~/integrations/yahoo/queries.js';

export interface CachedLatestPriceResponse {
	readonly ask: number | null;
	readonly askSize: number | null;
	readonly bid: number | null;
	readonly bidSize: number | null;
	readonly change: number | null;
	readonly changePercent: number | null;
	readonly currency: string | null;
	readonly exchange: string | null;
	readonly marketState: number | null;
	readonly price: number | null;
	readonly priceHint: number | null;
	readonly quoteType: string | null;
	readonly shortName: string | null;
	readonly staleAt: number;
	readonly symbol: string;
	readonly time: number | null;
	readonly volume: number | null;
}

function mapCachedMarketState(marketState: number | null | undefined): string | undefined {
	switch (marketState) {
		case 0:
			return 'PRE';
		case 1:
			return 'REGULAR';
		case 2:
			return 'POST';
		case 3:
			return 'POSTPOST';
		default:
			return undefined;
	}
}

export function mergeCachedLatestIntoFetch(
	existingFetch: InstrumentDisplayDataResponse,
	cachedPrice: CachedLatestPriceResponse,
): InstrumentDisplayDataResponse {
	const regularMarketTimeSeconds =
		typeof cachedPrice.time === 'number' && Number.isFinite(cachedPrice.time)
			? Math.floor(cachedPrice.time / 1000)
			: existingFetch.regularMarketTime;

	return {
		...existingFetch,
		ask: cachedPrice.ask ?? existingFetch.ask,
		askSize: cachedPrice.askSize ?? existingFetch.askSize,
		bid: cachedPrice.bid ?? existingFetch.bid,
		bidSize: cachedPrice.bidSize ?? existingFetch.bidSize,
		currency: cachedPrice.currency ?? existingFetch.currency,
		exchange: cachedPrice.exchange ?? existingFetch.exchange,
		marketState: mapCachedMarketState(cachedPrice.marketState) ?? existingFetch.marketState,
		priceHint: cachedPrice.priceHint ?? existingFetch.priceHint,
		quoteType: cachedPrice.quoteType ?? existingFetch.quoteType,
		regularMarketChange: cachedPrice.change ?? existingFetch.regularMarketChange,
		regularMarketChangePercent: cachedPrice.changePercent ?? existingFetch.regularMarketChangePercent,
		regularMarketPrice: cachedPrice.price ?? existingFetch.regularMarketPrice,
		regularMarketTime: regularMarketTimeSeconds,
		regularMarketVolume: cachedPrice.volume ?? existingFetch.regularMarketVolume,
		shortName: cachedPrice.shortName ?? existingFetch.shortName,
		symbol: cachedPrice.symbol,
	};
}
